import { createContext, useContext, type ReactNode } from 'react';
import { V2_READER_ROUTES, type ReaderRoutes } from '../utils/readerRoutes';

const ReaderRoutesContext = createContext<ReaderRoutes>(V2_READER_ROUTES);

/** The reader paths the views below link to; without a provider, the current reader's. */
export function ReaderRoutesProvider({ routes, children }: { routes: ReaderRoutes; children: ReactNode }) {
  return <ReaderRoutesContext.Provider value={routes}>{children}</ReaderRoutesContext.Provider>;
}

export function useReaderRoutes(): ReaderRoutes {
  return useContext(ReaderRoutesContext);
}
